import React from 'react';
import { Provider } from '../../../../../common/react-redux';
import store from '../../../../../reduxStore';
import BuildingButtons from '../BuildingButtons';
export var SDKBuildingButtons = function SDKBuildingButtons(props) {
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(BuildingButtons, props));
};
SDKBuildingButtons.displayName = 'SDKBuildingButtons';
export default SDKBuildingButtons;